import { useEffect } from 'react';

import type { AxiosConfigResolver, UseAxiosReturn } from '../../types';
import useAxiosCallback from './useAxiosCallback';

const useAxios = <TData = unknown>(axiosConfig: AxiosConfigResolver): UseAxiosReturn<TData> => {
    const [exec, loading, { error, response, data }] = useAxiosCallback<TData, AxiosConfigResolver>(axiosConfig);

    useEffect(() => {
        exec(axiosConfig);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return [data, loading, { error, response }];
};

export default useAxios;
